import { z } from "zod";

// Public request identifiers: sequential, zero-padded, generated by the database.
export const PUBLIC_ID_PATTERN = /^HOF-\d{6}$/;
export const PublicIdSchema = z.string().regex(PUBLIC_ID_PATTERN, "expected HOF-000000");
export type PublicId = z.infer<typeof PublicIdSchema>;
